import React from "react";
import "./RecentActivityHighlights.css";
import MessagePanel from "../../../theme/messagePanel/MessagePanel.js";
import { recent_activity_highlights } from "../../../config/constants";

const RecentActivityHighlights = () => {
  const sectionname = "Spotlight";
  const title = "Recent Activities";
  return (
    <div className="container recent-activities-container">
      <MessagePanel
        sectionname={sectionname}
        title={title}
        cardarray={recent_activity_highlights}
      />
    </div>
  );
};

export default RecentActivityHighlights;
